var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassToggleButtonGroup",
    {
      attrs: { value: _vm.activeFilter, exclusive: "" },
      on: { input: _vm.handleChange }
    },
    [
      _c("CompassToggleButton", {
        attrs: {
          value: "all",
          label: _vm.$t.__("timeline.TimelineEmailFilters.all")
        }
      }),
      _vm._v(" "),
      _c("CompassToggleButton", {
        attrs: {
          value: "emailengine.received",
          label: _vm.$t.__("timeline.TimelineEmailFilters.received")
        }
      }),
      _vm._v(" "),
      _c("CompassToggleButton", {
        attrs: {
          value: "emailengine.sent",
          label: _vm.$t.__("timeline.TimelineEmailFilters.sended")
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }